import React from "react"
import { FitlerSortCollapsibleRow } from "./filter-sort-collapsible-row"

type FilterValue = {
  value?: string
  label?: string
  count?: number
  field?: string
  active?: boolean
}

type FilterData = {
  field: string
  label: string
  values: FilterValue[]
}

type Props = {
  filterSortData: FilterData[]
  handleToggleFilter: (value: string) => void
  activeFilters: Set<string>
}

export function FilterSortDrawerFilterSort({
  filterSortData,
  handleToggleFilter,
  activeFilters,
}: Props) {
  return (
    <div className="filter-sort-options--container">
      {filterSortData?.length > 0 &&
        filterSortData.map((data) => (
          <FitlerSortCollapsibleRow
            key={data.field}
            data={data}
            handleToggleFilter={handleToggleFilter}
            activeFilters={activeFilters}
          />
        ))}
    </div>
  )
}
